




















import Widget from "@/components/common/Widget.vue";
import UmsatzHorizontalBar from "@/components/charts/UmsatzHorizontalBar.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    UmsatzHorizontalBar,
  },
})
export default class Top10KundenBereichFuenftUmsatz extends Vue {
  public static id = "Top10KundenBereichFuenftUmsatz";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return Top10KundenBereichFuenftUmsatz.id;
  }
  get _dprops() {
    return Top10KundenBereichFuenftUmsatz.dprops;
  }
}
